
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<aside class=\"modal-panel connect-another-device\">\n  <header>\n    <h1 id=\"fxa-why-connect-another-device-header\">{{#t}}Why sync multiple devices?{{/t}}</h1>\n  </header>\n\n  <p>\n    {{#t}}The Sync service isn’t a permanent backup, it’s simply a secure way to transfer saved bookmarks, history and passwords between your own devices.{{/t}}\n  </p>\n  <p>\n    {{#t}}You should install Firefox and sync at least two devices to protect against losing your data if you need to restore it but forget your password.{{/t}}\n  </p>\n  <div class=\"button-row\">\n    <button id=\"back\" type=\"submit\">{{#t}}Got it{{/t}}</button>\n  </div>\n</aside>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/why_connect_another_device.mustache
// module id = 307
// module chunks = app